module.exports = __webpack_public_path__ + "img/Strength-on@3x.2e83d8d4.png";